module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/fonts/basis_grotesque_medium-f175c9291ab9ee09fbe72502df61b7b9.woff";